function filterAndReplace(arr, searchString) {
    let foundFirstContent = false;
    return arr.filter(obj => {
        if (foundFirstContent) {
            obj.content = obj.content.replace(searchString, '').trim();
            return true;
        } else if (obj.content.includes(searchString)) {
            foundFirstContent = true;
            obj.content = obj.content.replace(searchString, '').trim();
            return true;
        }
        return false;
    }).filter(obj => obj.content !== '').map((_, i, a) => a[i ^ 1]).reverse();
}

export { filterAndReplace }